import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Event from '@util/GAEvent';
import MainButton from '@elements/MainButton';

const FadeInDiv = styled.div`
	transition-duration: 0.5s;
`;

const CTAMenu = styled.div`
	display: flex;
	align-items: center;
	gap: 2.4rem;
`;

const HeaderLink = styled(Link)`
	font-family: ${({ theme }) => theme.fonts.subheadingMedium};
	font-size: 1.5rem;
	line-height: 100%; /* 15px */
	letter-spacing: 0.15px;
	color: ${({ theme, darkMode }) =>
		darkMode ? theme.colors.white.main : theme.colors.black.main};

	:hover {
		color: ${({ theme }) => theme.colors.primary.main};
	}
`;

const CTAButton = styled(MainButton)`
	font-size: 1.5rem;
	letter-spacing: 0.15px;
`;

const MainNavCTA = ({ className, darkMode }) => {
	return (
		<FadeInDiv className={className}>
			<CTAMenu>
				<HeaderLink
					id="header-sign-in-button"
					className="header-sign-in-button"
					to="/sign-in"
					darkMode={darkMode}
				>
					<Event
						action={`Clicked sign-in button`}
						category="User"
						label="Sign In"
						value="Sign In"
					>
						Sign In
					</Event>
				</HeaderLink>
				<CTAButton linkUrl="/contact-sales/">
					<Event
						action={`Clicked "talk to an sales" in Nav`}
						category="User"
						label="Submittable User"
					>
						Talk to Sales
					</Event>
				</CTAButton>
			</CTAMenu>
		</FadeInDiv>
	);
};

export default MainNavCTA;
